import { useEffect } from 'react';

export const useResize = (action: () => any) => {
  useEffect(() => {
    window.addEventListener('resize', action);

    return () => {
      window.removeEventListener('resize', action);
    };
  }, []);
};
